import React, { useState } from 'react';
import HeadersForm from './headers_form';
import HeadersList from './headers_list';
import styles from '../../app.module.css'

const HeadersSection = ({ headers, addHeader, editHeader, removeHeader }) => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [currentHeader, setCurrentHeader] = useState(null);
  const [newHeader, setNewHeader] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [tempHeader, setTempHeader] = useState({
    name: '',
    required: false,
    description: '',
    schema: { type: '' },
  });

  const showPopupModal = (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  }

  const handleEdit = (headerName) => {
    setCurrentHeader(headerName);
    setTempHeader({ name: headerName, ...headers[headerName] });
  };

  const handleSave = () => {
    if (!tempHeader.name.trim()) {
      showPopupModal("Header name is required.");
      return;
    }

    const { name, ...headerData } = tempHeader;

    if (!currentHeader && headers[tempHeader.name]) {
      showPopupModal(`A header with the name "${tempHeader.name}" already exists. Please use a different name.`);
      return;
    }
    if (currentHeader) {
      editHeader(currentHeader, headerData);
    } else {
      addHeader(tempHeader.name, headerData);
    }
    setCurrentHeader(null);
    setPopupVisible(false);
    setNewHeader(false);
    setTempHeader({ name: '', required: false, description: '', schema: { type: '' } });
  };

  const handleCancel = () => {
    setCurrentHeader(null);
    setPopupVisible(false);
    setNewHeader(false);
    setTempHeader({ name: '', required: false, description: '', schema: { type: '' } });
  };

  return (
    <div className="headers-container">
      <h3 className={styles.centeredHeading}>Headers</h3>
      <div>
        <HeadersList
          headers={headers}
          onEdit={handleEdit}
          onDelete={removeHeader}
          currentHeader={currentHeader}
          tempHeader={tempHeader}
          setTempHeader={setTempHeader}
          handleSave={handleSave}
          handleCancel={handleCancel}
        />

        {!newHeader && !currentHeader && (
          <button className={styles.addNewButton} onClick={() => setNewHeader(true)}>
            + Add Header
          </button>
        )}

        {newHeader && (
          <div className={styles.mainContainer}>
            <label>Name: <span className={styles.requiredField}>*</span></label>
            <input
              type="text"
              value={tempHeader.name}
              onChange={(e) => setTempHeader({ ...tempHeader, name: e.target.value })}
              placeholder="Enter Header Name"
              className={styles.textBox}
            />

            <label>Description:</label>
            <textarea
              value={tempHeader.description}
              onChange={(e) => setTempHeader({ ...tempHeader, description: e.target.value })}
              placeholder="Enter description"
              className={styles.textBox}
            />

            <label>Type:</label>
            <select
              value={tempHeader.schema.type}
              onChange={(e) => setTempHeader({
                ...tempHeader,
                schema: { ...tempHeader.schema, type: e.target.value }
              })}
              className={styles.textBox}
            >
              <option value="">Select Type</option>
              <option value="string">String</option>
              <option value="integer">Integer</option>
              <option value="boolean">Boolean</option>
              <option value="array">Array</option>
              <option value="object">Object</option>
            </select>

            <label>
              Required:
              <input
                type="checkbox"
                checked={tempHeader.required}
                onChange={(e) => setTempHeader({ ...tempHeader, required: e.target.checked })}
              />
            </label>

            <div className={styles.sNcButtonContainer}>
              <button className={styles.saveButton} onClick={handleSave}>
                Add Header
              </button>
              <button className={styles.cancelButton} onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
      {
        showPopup && (
          <div className={styles.popupOverlay}>
            <div className={styles.popup}>
              <h3>Error</h3>
              <p>{popupMessage}</p>
              <button onClick={() => setShowPopup(false)} className="popup-close-button">
                OK
              </button>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default HeadersSection;
